export default {"src":"/_next/static/media/TrueCar.750fb12f.svg","height":18,"width":89,"blurWidth":0,"blurHeight":0};